import(/* webpackMode: "eager" */ "/codebuild/output/src3823956198/src/legalo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3823956198/src/legalo/src/components/LoaderComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/codebuild/output/src3823956198/src/legalo/src/contexts/authContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoaderProvider"] */ "/codebuild/output/src3823956198/src/legalo/src/contexts/loaderContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/codebuild/output/src3823956198/src/legalo/src/contexts/toastContext.tsx");
